export const DEFAULT_LAYOUT_PADDING = 24
